export default "__VITE_ASSET__CeBmQWrO__"